const accountsRoot = "/accounts";
const managersRoot = "/managers";
const billingRoot = "/billing";

export enum AdminDashboardRoutesAccountSections {
  Settings = "settings",
  AccreditationVerification = "accreditation-verifications",
  BankAccounts = "bank-account",
  DistributionPreferences = "distribution-preferences",
  Holdings = "holdings",
  IdentityVerifications = "identity-verifications",
  Investments = "investments",
  RelatedAccounts = "related-accounts",
  MergeAccounts = "merge-accounts",
  Users = "users",
}

export enum AdminDashboardRoutesManagerSections {
  Settings = "settings",
  Attributes = "attributes",
  TrackRecord = "trackRecord",
  TrackRecordDocuments = "track-record-documents",
  Contact = "contact",
  Employees = "employees",
  Images = "images",
  Principals = "principals",
  Opportunities = "opportunities",
  UserRoles = "user-roles",
}

export enum AdminDashboardRoutesManagerPrincipalSections {
  Settings = "settings",
  BackgroundChecks = "background",
  EducationAndLicenses = "education",
  EmploymentHistory = "employment",
}

export enum AdminDashboardRoutesManagerOpportunitySections {
  Settings = "settings",
  Documents = "documents",
  GalleryImages = "gallery-images",
  PortalImages = "portal-images",
  Instructions = "instructions",
  KeyPoints = "key-points",
  Media = "media",
  Offerings = "offerings",
  Schedule = "schedule",
}

export enum AdminDashboardRoutesBillingSections {
  Events = "events",
  Products = "products",
  Entities = "entities",
  Invoices = "invoices",
}

export enum AdminDashboardRoutesManagerOpportunityOfferingSections {
  Securities = "securities",
}

export const AdminDashboardAccountDetailsInvestmentsRoutes = {
  ACCOUNTS_DETAILS_INVESTMENTS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}`,
  ACCOUNTS_DETAILS_INVESTMENTS_NEW: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/0`,
  ACCOUNTS_DETAILS_INVESTMENT_DETAILS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment`,
  ACCOUNTS_DETAILS_INVESTMENT_DISTRIBUTION_PREFERENCES: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/distribution-preferences`,
  ACCOUNTS_DETAILS_INVESTMENT_DISTRIBUTION_PREFERENCES_ADD: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/distribution-preferences/0`,
  ACCOUNTS_DETAILS_INVESTMENT_DISTRIBUTION_PREFERENCES_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/distribution-preferences/:idDistributionPreference`,
  ACCOUNTS_DETAILS_INVESTMENT_DOCUMENTS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/documents`,
  ACCOUNTS_DETAILS_INVESTMENT_DOCUMENT_ADD: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/documents/0`,
  ACCOUNTS_DETAILS_INVESTMENT_DOCUMENT_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/documents/:idDocument`,
  ACCOUNTS_DETAILS_INVESTMENT_INVESTOR_ASSISTS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/investor-assists`,
  ACCOUNTS_DETAILS_INVESTMENT_INVESTOR_ASSIST_ADD: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/investor-assists/0`,
  ACCOUNTS_DETAILS_INVESTMENT_INVESTOR_ASSIST_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Investments}/:idInvestment/investor-assists/:idInvestorAssist`,
};

export const AdminDashboardAccountDetailsHoldingRoutes = {
  ACCOUNTS_DETAILS_HOLDINGS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Holdings}`,
  ACCOUNT_DETAILS_EDIT_HOLDING: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Holdings}/:idHolding?`,
  ACCOUNT_DETAILS_HOLDING_CALCS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Holdings}/:idHolding/holding-calcs`,
  ACCOUNT_DETAILS_HOLDING_CALCS_ADD: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Holdings}/:idHolding/holding-calcs/0`,
  ACCOUNT_DETAILS_HOLDING_CALCS_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Holdings}/:idHolding/holding-calcs/:idHoldingCalc`,
  ACCOUNT_DETAILS_HOLDING_RETITLE: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.Holdings}/:idHolding/retitle`,
};

export const AdminDashboardAccountDetailsDistributionPreferenceRoutes = {
  ACCOUNTS_DETAILS_DISTRIBUTION_PREFERENCES: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.DistributionPreferences}`,
  ACCOUNTS_DETAILS_DISTRIBUTION_PREFERENCES_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.DistributionPreferences}/:idDistributionPreference`,
};

export const AdminDashboardAccountDetailsAccreditationVerificationsRoutes = {
  ACCOUNTS_DETAILS_ACCREDITATION_VERIFICATIONS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.AccreditationVerification}`,
  ACCOUNTS_DETAILS_ACCREDITATION_VERIFICATIONS_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.AccreditationVerification}/:idAccreditationVerification`,
};

export const AdminDashboardAccountDetailsIdentityVerificationRoutes = {
  ACCOUNTS_DETAILS_IDENTITY_VERIFICATIONS: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.IdentityVerifications}`,
  ACCOUNTS_DETAILS_IDENTITY_VERIFICATIONS_EDIT: `${accountsRoot}/:idAccount/${AdminDashboardRoutesAccountSections.IdentityVerifications}/:idIdentityVerification`,
};

export const AdminDashboardManagerDetailsTrackRecordRoutes = {
  MANAGERS_DETAILS_TRACK_RECORD: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.TrackRecord}`,
  MANAGERS_DETAILS_TRACK_RECORD_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.TrackRecord}/:idTrackRecord`,
  MANAGERS_DETAILS_TRACK_RECORD_DOCUMENTS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.TrackRecord}/documents`,
};

export const AdminDashboardManagerDetailsEmployeeRoutes = {
  MANAGERS_DETAILS_EMPLOYEES: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Employees}`,
  MANAGERS_DETAILS_EMPLOYEES_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Employees}/0`,
  MANAGERS_DETAILS_EMPLOYEES_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Employees}/:idEmployee`,
};

export const AdminDashboardManagerDetailsOpportunitiesRoutes = {
  MANAGERS_DETAILS_OPPORTUNITIES: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}`,
  MANAGERS_DETAILS_OPPORTUNITIES_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/0`,
  MANAGERS_DETAILS_OPPORTUNITIES_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity`,
  MANAGERS_DETAILS_OPPORTUNITIES_DETAILS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity`,
};

export const custodianIdParam = "custodianId";
export const AdminDashboardCustodianRoutes = {
  CUSTODIANS: "/custodians",
  CUSTODIAN_DETAILS: `/custodians/:${custodianIdParam}`,
};

export const AdminDashboardManagerDetailsPrincipalsRoutes = {
  MANAGERS_DETAILS_PRINCIPALS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_BACKGROUND_CHECKS_DETAILS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.BackgroundChecks}/:idBackgroundCheck`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_EMPLOYMENT_HISTORY: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.EmploymentHistory}`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_EMPLOYMENT_HISTORY_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.EmploymentHistory}/0`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_EMPLOYMENT_HISTORY_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.EmploymentHistory}/:idHistory`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_EDUCATION_AND_LICENCES: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.EducationAndLicenses}`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_EDUCATION_AND_LICENCES_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.EducationAndLicenses}/0`,
  MANAGERS_DETAILS_PRINCIPALS_DETAILS_EDUCATION_AND_LICENCES_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Principals}/:idPrincipal/${AdminDashboardRoutesManagerPrincipalSections.EducationAndLicenses}/:idHistory`,
};

export const AdminDashboardManagerUserRoleRoutes = {
  MANAGERS_USER_ROLES: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.UserRoles}`,
  MANAGERS_USER_ROLES_ADD: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.UserRoles}/0`,
  MANAGERS_USER_ROLES_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.UserRoles}/:idUserRole`,
};

export const AdminDashboardManagerOpportunitiesRoutes = {
  MANAGER_OPPORTUNITIES_KEY_POINTS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.KeyPoints}`,
  MANAGER_OPPORTUNITIES_KEY_POINTS_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.KeyPoints}/:idKeyPoint`,
  MANAGER_OPPORTUNITIES_KEY_POINTS_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.KeyPoints}/0`,
  MANAGER_OPPORTUNITIES_MEDIA: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Media}`,
  MANAGER_OPPORTUNITIES_MEDIA_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Media}/:idMedia`,
  MANAGER_OPPORTUNITIES_MEDIA_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Media}/0`,
  MANAGER_OPPORTUNITIES_OFFERINGS: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Offerings}`,
  MANAGER_OPPORTUNITIES_OFFERINGS_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Offerings}/:idOffering`,
  MANAGER_OPPORTUNITIES_OFFERINGS_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Offerings}/0`,
  MANAGER_OPPORTUNITIES_OFFERINGS_SECURITIES: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Offerings}/:idOffering/${AdminDashboardRoutesManagerOpportunityOfferingSections.Securities}`,
  MANAGER_OPPORTUNITIES_OFFERINGS_SECURITIES_EDIT: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Offerings}/:idOffering/${AdminDashboardRoutesManagerOpportunityOfferingSections.Securities}/:idSecurity`,
  MANAGER_OPPORTUNITIES_OFFERINGS_SECURITIES_NEW: `${managersRoot}/:idManager/${AdminDashboardRoutesManagerSections.Opportunities}/:idOpportunity/${AdminDashboardRoutesManagerOpportunitySections.Offerings}/:idOffering/${AdminDashboardRoutesManagerOpportunityOfferingSections.Securities}/0`,
};

export const AdminDashboardBillingRoutes = {
  BILLING_PRODUCTS: `${billingRoot}/${AdminDashboardRoutesBillingSections.Products}`,
  BILLING_PRODUCTS_NEW: `${billingRoot}/${AdminDashboardRoutesBillingSections.Products}/0`,
  BILLING_PRODUCTS_DETAILS: `${billingRoot}/${AdminDashboardRoutesBillingSections.Products}/:idBillingProduct`,
  BILLING_PRODUCTS_DETAILS_PRICES: `${billingRoot}/${AdminDashboardRoutesBillingSections.Products}/:idBillingProduct/prices`,
  BILLING_PRODUCTS_DETAILS_PRICES_NEW: `${billingRoot}/${AdminDashboardRoutesBillingSections.Products}/:idBillingProduct/prices/0`,
  BILLING_PRODUCTS_DETAILS_PRICES_EDIT: `${billingRoot}/${AdminDashboardRoutesBillingSections.Products}/:idBillingProduct/prices/:idBillingPrice`,
  BILLING_ENTITIES: `${billingRoot}/${AdminDashboardRoutesBillingSections.Entities}`,
  BILLING_ENTITIES_NEW: `${billingRoot}/${AdminDashboardRoutesBillingSections.Entities}/0`,
  BILLING_ENTITIES_EDIT: `${billingRoot}/${AdminDashboardRoutesBillingSections.Entities}/:idBillingEntity`,
  BILLING_EVENTS: `${billingRoot}/${AdminDashboardRoutesBillingSections.Events}`,
  BILLING_EVENTS_NEW: `${billingRoot}/${AdminDashboardRoutesBillingSections.Events}/0`,
  BILLING_EVENTS_EDIT: `${billingRoot}/${AdminDashboardRoutesBillingSections.Events}/:idBillingEvent`,
};

export const AdminDashboardRoutes = {
  USER_SETTINGS: "/user/settings",
  HOME: "/",
  ACCOUNTS: accountsRoot,
  ACCOUNTS_DETAILS: `${accountsRoot}/:id/:section?/:idSection?/:section2?/:idSection2?`,
  ACCOUNTS_CREATE: `${accountsRoot}/0`,
  ACCOUNTS_DETAILS_MERGE_ACCOUNTS: `${accountsRoot}/:idAccount/merge-accounts`,
  SPONSORS: "/sponsors",
  SPONSOR_DETAILS:
    "/sponsors/:id/:section?/:idSection?/:section2?/:idSection2?",
  MANAGERS: managersRoot,
  MANAGERS_CREATE: `${managersRoot}/0`,
  MANAGERS_DETAILS: `${managersRoot}/:id/:section?/:idSection?/:section2?/:idSection2?/:section3?/:idSection3?`,
  TENANTS: "/tenants",
  USERS: "/users",
  USERS_DETAILS: "/users/:id",
  VERIFICATIONS: "/verifications",
  FUNDS: "/funds",
  BILLING: "/billing",
  BILLING_DETAILS:
    "/billing/:section?/:idSection?/:section2?/:idSection2?/:section3?/:idSection3?",
  ...AdminDashboardCustodianRoutes,
  ...AdminDashboardAccountDetailsInvestmentsRoutes,
  ...AdminDashboardAccountDetailsHoldingRoutes,
  ...AdminDashboardAccountDetailsDistributionPreferenceRoutes,
  ...AdminDashboardAccountDetailsAccreditationVerificationsRoutes,
  ...AdminDashboardAccountDetailsIdentityVerificationRoutes,
  ...AdminDashboardManagerDetailsTrackRecordRoutes,
  ...AdminDashboardManagerDetailsEmployeeRoutes,
  ...AdminDashboardManagerDetailsOpportunitiesRoutes,
  ...AdminDashboardManagerDetailsPrincipalsRoutes,
  ...AdminDashboardManagerUserRoleRoutes,
  ...AdminDashboardManagerOpportunitiesRoutes,
  ...AdminDashboardBillingRoutes,
};
